import {
  IPB_DIRECTORY_MODERATION_LISTING,
  IPB_DIRECTORY_MODERATION_LISTING_ERROR,
  CLEAN_IPB_DIRECTORY_MODERATION_LISTING,
  CLEAN_IPB_DIRECTORY_MODERATION_LISTING_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function ipbDirectoryModerationListingReducer(state = initialState, action) {
  switch (action.type) {
    case IPB_DIRECTORY_MODERATION_LISTING:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case IPB_DIRECTORY_MODERATION_LISTING_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_IPB_DIRECTORY_MODERATION_LISTING:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_IPB_DIRECTORY_MODERATION_LISTING_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };

    default:
      return state;
  }
}
